export const formContent = {
    heading: 'Your details',
    profilePic: {
        id: 'profilePic',
        label: '',
        defaultImage: '/img/blank-avatar.jpeg'
    },
    userType: {
        id: 'userType',
        label: 'User type',
        options: [
            { value: 'buyer', label: 'Member' },
            { value: 'supplier', label: 'Business' }
        ],
        disabled: true
    },
    firstName: {
        id: 'firstName',
        label: 'First name',
        validation: {
            required: "First name is required"
        }
    },
    lastName: {
        id: 'lastName',
        label: 'Last name',
        validation: {
            required: "Last name is required"
        }
    },
    mobileNo: {
        id: 'mobileNo',
        label: 'Phone',
        validation: {
            required: "Phone is required"
        }
    },
    emailAddress: {
        id: 'emailAddress',
        label: 'Email',
        disabled: true
    },
    city: {
        id: 'city',
        label: 'City / Suburb',
        validation: {
            required: "City / suburb is required"
        },
        addressType:'(cities)'
    },
    state: {
        id: 'state',
        label: 'State',
        validation: {
            required: "State is required"
        }
    },
    postalCode: {
        id: 'postalCode',
        label: 'Postal Code',
        validation: {
            required: "Postal Code is required"
        }
    },
    updateButton: {
        id: 'updateButton',
        label: 'Update profile',
        type: 'submit'
    }
}
